angular.module('impactx.address').controller('AddressDetailCtrl', AddressDetailCtrl);

AddressDetailCtrl.$inject = ['$scope',
    'dataGen',
    'selectedListItems',
    '$mdToast',
    'BackService',
    '$routeParams',
    'ConfirmationService',
    'ToolbarService'
];

/**
 * Thanks to AddressDirectiveController this one does not need to deal with pre-set data anymore.
 */
function AddressDetailCtrl($scope, dataGen, selectedListItems, $mdToast, BackService, $routeParams, ConfirmationService, ToolbarService) {
    var adrId, ctrl = this;

    var ADDRESS_SIZE = 'FULL_DIALOG';
    $scope.expandAddress = false;
    $scope.expandContact = false;
    $scope.data = {};

    if ($routeParams.id) {
        adrId = $routeParams.id;
    }
    else if (selectedListItems.getFirstSelectedId()) {
        adrId = selectedListItems.getFirstSelectedId();
    }
    else {
        adrId = 0;
    }

    ctrl.prepareDataForSave = function (data) {
        var dataToSend = {};

        angular.copy(data, dataToSend);
        dataToSend.country = dataGen.slimDownPopup(dataToSend.country);

        return dataToSend;
    };

    ctrl.save = function (saveCopy) {
        $scope.data.adr.addressSize = ADDRESS_SIZE;
        delete $scope.data.adr.country.entries;
        delete $scope.data.adr.owningCom.entries;

        var entryPoint = saveCopy ? "/address/saveas" : "/address/save";
        return dataGen.postAsForm($scope, {address: ctrl.prepareDataForSave($scope.data.adr)}, entryPoint).then(function () {
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.save_success)
                    .position("bottom right")
                    .hideDelay(10000)
            );
            BackService.back();
        })
    };

    ctrl.handleNuts = function () {
        var address,
            scope = {};

        address = $scope.data.adr;

        if (address.zip && address.country.selected) {
            return dataGen.postAsForm(scope, {
                zip: address.zip.value,
                ctyId: address.country.selected.id
            }, "/address/ziptonuts").then(function () {
                var bestNuts, availableNuts, currentNuts;

                currentNuts = address.nutsCode.value;
                bestNuts = scope.data.bestCode;
                availableNuts = scope.data.options;
                
                if ((currentNuts && availableNuts.indexOf(currentNuts) !== -1) || !address.nuts) {
                    if (!address.nutsCode.value) {
                        address.nutsCode.value = bestNuts;
                    }
                }

                $scope.availableNuts = availableNuts;
            });
        }
    };

    ctrl.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    ctrl.delete = function () {
        var dataObj = {
            id: $scope.data.adr.addressId
        };
        dataGen.postAsForm($scope, dataObj, "/address/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    ctrl.checkVisible = function (field) {
        if (field) {
            return field.visible || false;
        }
        return false;
    };

    ctrl.checkRequired = function (field) {
        if (field) {
            if (field.showMust) {
                return true;
            }
            return field.requiredIfContactAddress && $scope.data.adr.isContactAddress.value
        }
        return false;
    }

    ctrl.toggleAdditionalFields = function () {
        angular.forEach($scope.data.adr.additionalFields, function (fieldName) {
            var field = impactX.isDefined($scope, 'data.adr.'+fieldName);
            if (field && !(field.value || ctrl.hasPhoneValue(field))) {
                field.visible = !field.visible;
            }
        })
    }

    ctrl.hasPhoneValue = function (field) {
        return impactX.isDefined(field, 'coutryCode.value') ||
            impactX.isDefined(field, 'areaCode.value') ||
            impactX.isDefined(field, 'networkCode.value') ||
            impactX.isDefined(field, 'numberCode.value');
    }

    dataGen.getData({}, {id: adrId, size: ADDRESS_SIZE}, "/address/view").then(function (data) {
        if (!$scope.data) {
            $scope.data = {};
        }
        $scope.data.adr = data.data.adr;
        $scope.trns = data.trns;
        ctrl.handleNuts();
        defineButtons();
        $scope.restricted = !impactX.isDefined($scope, 'data.adr.hasRightToEdit') && impactX.isDefined($scope, 'data.adr.hasRightToEditRestricted');
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: function () {
                    return ctrl.save(false);
                },
                type: 'validation',
                condition: canEdit,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.saveAs,
                action: function () {
                    return ctrl.save(true);
                },
                type: 'validation',
                condition: canCreate,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            },
            {
                label: $scope.trns.toggleAdditional,
                action: ctrl.toggleAdditionalFields,
                type: 'dialogaction',
                condition: canToggle
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canEdit() {
        return impactX.isDefined($scope, 'data.adr.hasRightToEdit') || impactX.isDefined($scope, 'data.adr.hasRightToEditRestricted');
    }

    function canCreate() {
        var adr = impactX.isDefined($scope, 'data.adr');
        return adr.hasRightToCreate && adr.addressId > 0;
    }

    function canDelete() {
        return !$scope.data.adr.readOnly && $scope.data.adr.hasRightToDelete;
    }

    function canToggle() {
        return $scope.data.adr.additionalFields && $scope.data.adr.additionalFields.length > 0;
    }
}